import React from 'react';
import './dueDiligenceNotificationBanner.scss';
import { DueDiligenceStatus } from '@constants/DueDiligence';

interface IDueDiligenceNotificationProps {
    link: string;
    status: string;
}

export const DueDiligenceNotificationBanner: React.FC<IDueDiligenceNotificationProps> = ({ link, status }) => {
    return (
        <div className="banner-dueDiligence">
            <div className="banner">
                <p className="banner--text">
                    <span>
                        {status == DueDiligenceStatus.NOTIFIED && (
                            <>
                                <span className="banner--bold">¡Tu información está próxima a vencer! </span>ara seguir realizando
                                pagos sin interrupciones, es importante que actualices tu información en nuestro formulario de
                                Debida Diligencia antes de la fecha de vencimiento. Si no la actualizas a tiempo, no podrás
                                generar la renovación de tu plan activo.
                                <span className="banner--bold">
                                    No te esperes hasta el último momento; actualiza tu información aquí.{' '}
                                </span>
                            </>
                        )}
                        {status == DueDiligenceStatus.FOR_NEW_CREATION && (
                            <>
                                <span className="banner--bold">¡Tu información está desactualizada!</span> Si quieres seguir
                                haciendo uso de nuestros servicios sin restricciones, debes actualizar tu información en nuestro
                                formulario de Debida Diligencia.
                                <span className="banner--bold">
                                    Si no la actualizas, no podrás generar la renovación de tu plan activo.{' '}
                                </span>
                            </>
                        )}
                        <a href={link} target="_blank" rel="noopener noreferrer" className="banner--link">
                            Actualiza tu información aquí.
                        </a>
                    </span>
                </p>
                <br />
                <span>Una vez hayas actualizado la información, recarga el portal de Nómina en Línea.</span>
            </div>
        </div>
    );
};
